module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newadministrator"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("创建新管理员")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("用户名")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.admin_info.username),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "username", $$v)
      },
      expression: "admin_info.username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.admin_info.password),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "password", $$v)
      },
      expression: "admin_info.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("显示名")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入显示名"
    },
    model: {
      value: (_vm.admin_info.display_name),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "display_name", $$v)
      },
      expression: "admin_info.display_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.admin_info.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "phone_number", $$v)
      },
      expression: "admin_info.phone_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("手机验证")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "disabled": !_vm.admin_info.phone_number,
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.phone_verified),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "phone_verified", $$v)
      },
      expression: "admin_info.phone_verified"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入Email地址"
    },
    model: {
      value: (_vm.admin_info.email),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "email", $$v)
      },
      expression: "admin_info.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("Email验证")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "disabled": !_vm.admin_info.email,
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.email_verified),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "email_verified", $$v)
      },
      expression: "admin_info.email_verified"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("是否激活")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.is_active),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "is_active", $$v)
      },
      expression: "admin_info.is_active"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("是否雇员")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.is_staff),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "is_staff", $$v)
      },
      expression: "admin_info.is_staff"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("权限组设置")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function (value) {
        _vm.admin_info.permission_group_id = value
      }
    },
    model: {
      value: (_vm.admin_info.permission_group_id),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "permission_group_id", $$v)
      },
      expression: "admin_info.permission_group_id"
    }
  }, _vm._l((_vm.permission_group), function(item) {
    return _c('a-select-option', {
      key: item,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.permission_group_name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("是否CMS管理员")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.is_cms),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "is_cms", $$v)
      },
      expression: "admin_info.is_cms"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("是否超级管理员")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.is_super),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "is_super", $$v)
      },
      expression: "admin_info.is_super"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.newadmin
    }
  }, [_vm._v("确定")])], 1)])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b8cede0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/usermanagement/newadministrator/index.vue
// module id = 2390
// module chunks = 1